import { render } from "./FooterAdmin.vue?vue&type=template&id=5c64dc96"
import script from "./FooterAdmin.vue?vue&type=script&lang=js"
export * from "./FooterAdmin.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\vue-notus-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__